import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./utils/protectedRoute";

import { ConfigProvider } from "antd";

import HomeScreen from "./website/homeScreen";
import ContactScreen from "./website/contactScreen";
import LoginScreen from "./website/loginScreen";
import AdminRoute from "./admin/route";
import Invoice from "./website/invoice";
import Features from "./website/features";
import HowItWorks from "./website/howItWorks";
import BiometricIntegration from "./website/biometricIntegration";
import ContactUs from "./website/contact";
import ForgotPassword from "./website/forgotPassword";

function App() {
  const User = useSelector((state: any) => state.User);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#000",
          fontFamily: "DMSans-Regular",
          borderRadius: 2,
        },
      }}
    >
      <Routes>
        <Route index element={<HomeScreen />} />;
        <Route path="/contact" element={<ContactScreen />} />;
        <Route path="/login" element={<LoginScreen />} />;
        <Route path="/invoice/:transactionId" element={<Invoice />} />;
        <Route path="/features" element={<Features />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route
          path="/biometricintegration"
          element={<BiometricIntegration />}
        />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/reset-password/:token" element={<ForgotPassword />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute isSignedIn={User.auth}>
              <AdminRoute />
            </ProtectedRoute>
          }
        />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
